var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 240,
    viewBox: "0 0 241 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 0L122.058 108.587C122.135 113.997 126.503 118.365 131.913 118.442L240.5 120L131.913 121.558C126.503 121.635 122.135 126.003 122.058 131.413L120.5 240L118.942 131.413C118.865 126.003 114.497 121.635 109.087 121.558L0.5 120L109.087 118.442C114.497 118.365 118.865 113.997 118.942 108.587L120.5 0Z",
    fill: "#E4E1E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarWhite);
export default __webpack_public_path__ + "static/media/star-white.05ac5ee25977c81df3a123fa15726801.svg";
export { ForwardRef as ReactComponent };